var e = function e(t) {
  if ("undefined" == typeof document) return 0;

  if (document.body && (!document.readyState || "loading" !== document.readyState)) {
    if (!0 !== t && "number" == typeof e.__cache) return e.__cache;
    var o = document.createElement("div"),
        d = o.style;
    d.display = "block", d.position = "absolute", d.width = "100px", d.height = "100px", d.left = "-999px", d.top = "-999px", d.overflow = "scroll", document.body.insertBefore(o, null);
    var n = o.clientWidth;
    if (0 !== n) return e.__cache = 100 - n, document.body.removeChild(o), e.__cache;
    document.body.removeChild(o);
  }
};

export { e as scrollbarWidth };